/**
 * Created by Tamale Dev.
 * Description:
 *
 * ------ maintenance history ------
 * Updated by Daniel Wang on 1/13/202, Removed email digest and changed the order of the tabs.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../redux';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../services/layout.service';
import { FloatMenuService } from '../../services/float-menu.service';
import { businessConstants } from '../../constants/business.constants';
import { GlobalService, GlobalActionType } from '../../tamalelibs/services/global.service';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'tam-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, OnDestroy {

    tabData: Array<any> = [
        {
            title: 'Data Management',
            disabled: false,
            editable: false,
        },
        {
            title: 'Manage Screens',
            disabled: false,
            editable: false,
        },
        {
            title: 'Advanced',
            disabled: false,
            editable: false,
        },
    ];
    currentTab: number;
    currentUser: SystemUser;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _route: ActivatedRoute,
        private _layoutService: LayoutService,
        private _floatMenuService: FloatMenuService,
        private _router: Router,
        private _globalService: GlobalService,
        private _storeQuerierService: StoreQuerierService,
    ) { }

    ngOnInit() {
        this.currentUser = this._storeQuerierService.getCurrentUser();
        if (this.currentUser.credential.admin) {
            const adminConsole = {
                title: 'Administrative Console',
                disabled: false,
                editable: false,
            };
            this.tabData = [adminConsole, ...this.tabData];
        }
        this.initTabOptions();
        this._layoutService.changeSubTitleTopOpen$.next('111px');
        this._floatMenuService.floatMenuBottomSubject$.next(false);
        const currentPageInfo: any = {
            url: this._route.snapshot.url,
            name: 'Settings',
            type: 'SETTINGS',
            screenType: businessConstants.screenType.settings,
        };
        this._store.dispatch({
            type: ScreenActionTypes.SET_VALUE,
            payload: currentPageInfo
        });
        this.handleRouting(this._router.url);
        this._globalService.actionSubject$.next({
            type: GlobalActionType.DISABLE_GLOBAL_BUFFER,
            payload: true,
        });
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._layoutService.changeSubTitleTopOpen$.next('119px');
        this._floatMenuService.floatMenuBottomSubject$.next(true);
        this._globalService.actionSubject$.next({
            type: GlobalActionType.DISABLE_GLOBAL_BUFFER,
            payload: false,
        });
    }

    initTabOptions() {
        this._destroySubscriptions.push(
            this._router.events.pipe(
                filter(event => event instanceof NavigationEnd),
            ).subscribe(event => {
                this.handleRouting(this._router.url);
            }),
        );
    }

    selectTabChange($event) {
        let index = 0;
        if (this.currentUser.credential.admin) {
            index = 0;
        } else {
            index = -1;
        }
        this.currentTab = $event;
        let route: string;
        switch (this.currentTab) {
            case index + 1:
                route = 'data';
                break;
            case index + 2:
                route = 'screens';
                break;
            case index + 3:
                route = 'advanced';
                break;
            case index:
            default:
                route = 'admin-console';
                break;
        }
        this._router.navigate(['settings', route]);
    }

    handleRouting(route: string) {
        let index = 0;
        if (this.currentUser.credential.admin) {
            index = 0;
        } else {
            index = -1;
        }

        switch (route) {
            case '/settings/data':
                this.currentTab = index + 1;
                break;
            case '/settings/screens':
                this.currentTab = index + 2;
                break;
            case '/settings/advanced':
                this.currentTab = index + 3;
                break;
            default:
                break;
        }
        if (route.startsWith('/settings/admin-console')) {
            if (this.currentUser.credential.admin) {
                this.currentTab = index;
            } else {
                this._router.navigate(['error']);
            }
        }
    }
}
